import React from 'react';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import { Text, TextTypography } from '@wix/wix-ui-tpa/cssVars';
import withTranslate from '../../../../common/hoc/with-translate';
import { classes } from './page-title.st.css';

type Props = Pick<WithTranslation, 't'>;

const PageTitle = ({ t }: Props) => (
  <Text className={classes.root} tagName="h2" typography={TextTypography.smallTitle}>
    {t('page-title')}
  </Text>
);

export default withTranslate(PageTitle);
